export interface UserData {
    userId: number | string;
    email: string;
    username: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    gender: "M" | "F" | "O";
    picture?: string;
    birthDate?: Date;
    emailVerified: boolean;
    creation: Date;
    authLevel: number | string;
    lastLogin?: Date;
    active: boolean;
}

export interface AdminData extends UserData {
    stations: string[]
}

export interface UserDataFilter {
    options: {
        gender: any[];
        emailVerified: boolean;
        active: boolean;
    },
    cache: {
        gender: any[];
        emailVerified: boolean;
        active: boolean;
    },
    values: {
        gender?: 'M' | 'F' | 'O';
        emailVerified?: boolean;
        active?: boolean;
    },
    applied: {
        gender?: 'M' | 'F' | 'O';
        emailVerified?: boolean;
        active?: boolean;
    }
}

export interface AdminDataFilter {
    options: {
    },
    cache: {
    },
    values: {
    },
    applied: {
    }
}

export function getDefaultUserData(): UserData {
    return structuredClone({
        userId: '',
        email: '',
        username: '',
        gender: 'O',
        emailVerified: true,
        creation: new Date(),
        authLevel: '9',
        active: true
    })
}

export function getDefaultAdminData(): AdminData {
    return structuredClone({
        userId: '',
        email: '',
        username: '',
        gender: 'O',
        emailVerified: true,
        creation: new Date(),
        authLevel: '1',
        active: true,
        stations: []
    })
}